import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg01.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Elevate Your Business With Boston’s Top App Development Experts
              </h2>
            </div>
            <p>
              At TekRevol, we take great pride in being the foremost hub for
              unleashing your brand's genuine potential through skilled app
              development. Our team consists of innovative designers,
              developers, and strategists who work together to propel your brand
              to success. Our premier app development team is the driving force
              behind our reputation for excellence.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
